<template>
  <el-drawer v-model="isShow" size="100%" :title="title" show-close>
    <div style="margin: 16px">
      <el-button @click="isShow = false">关闭</el-button>
      <div v-if="model" style="margin: 16px">
        <div>
          <!-- 项目申请书:
          <span class="blue cursor link" @click="openFile(model.FilePath)">点击查看</span> -->
        </div>
        <div style="margin: 16px" v-if="model.FilePaths && model.FilePaths.length > 0">
          附件列表
          <div v-for="item in model.FilePaths" :key="item">
            <span class="blue cursor link" @click="openFile(item)">点击查看</span>
          </div>
        </div>
        <div class="content-iframe" v-loading="loadingfranme">
          <iframe ref="Iframe" :src="path" class="iframe" v-if="workShow" @load="framLoad"></iframe>
        </div>
        <div class="demo-image__preview" v-if="isImgShow">
          <el-image style="width: 100px; height: 100px" :src="path" :previewSrcList="[path]" fit="cover">
          </el-image>
        </div>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { isImg } from "../../utils/utils";
import { GetEducationReformById } from "../../http/psychologyTemp";
export default {
  data() {
    return {
      model: {},
      isShow: false,
      loadingfranme: false,
      isImgShow: false,
      workShow: false,
      path: "",
      title: "",
    };
  },
  methods: {
    init(id, title, workType, mathId) {
      console.log(id)
      this.title = title;
      if (mathId === '1') {
        GetEducationReformById({ id: id, workType: workType }).then((res) => {
          this.isShow = true;
          this.model = res.Model;
          this.path = "";
          this.isImgShow = false;
          this.workShow = false;
        });
      } else if (mathId === '2') {
        GetEducationReformById({ id: id, workType: workType }).then((res) => {
          this.isShow = true;
          this.model = res.Model;
          this.path = "";
          this.isImgShow = false;
          this.workShow = false;
        });

      }

    },
    framLoad() {
      this.loadingfranme = false;
    },
    openFile(url) {
      this.loadingfranme = true;
      this.isImgShow = false;
      this.workShow = false;
      if (isImg(url)) {
        this.path = url;
        this.isImgShow = true;
        return;
      }
      if (
        url.indexOf(".xls") != -1 ||
        url.indexOf(".xlsx") != -1 ||
        url.indexOf(".doc") != -1 ||
        url.indexOf(".docx") != -1
      ) {
        this.path = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
          url
        )}`;
        this.workShow = true;
        return;
      } else if (url.indexOf(".pdf") != -1) {
        this.path = url;
        this.workShow = true;
        return;
      }
      window.open(url);
    },
  },
};
</script>
<style scoped>
.full {
  width: 100%;
}

.blue {
  color: #409eff;
}

.green {
  color: #20a474;
}

.cursor {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.content-iframe {
  margin-top: 15px;
}

.iframe {
  width: 100%;
  height: 680px;
}
</style>
